export default {
  'app.nome': 'SPA Sensorial',
  'app.sottotitolo': 'Relais Villa Carola',
  'avvio.carico': 'Starting…',
  'avvio.errore': 'The app cannot start. Check the connection and reopen it.',
  'avvio.riprova': 'Try again',
  'rete.no': 'Offline: everything stays saved on the phone',
  'invii.telefono': '⏳ Saved on the phone · sent when online',
  'invii.arrivato': '✓ Received',
  'invii.errore': '⚠️ Not saved ({codice})',
  'attesa.titolo': 'Welcome to the SPA',
  'attesa.spiega': 'Write your name and ask to join. The manager approves the phone.',
  'attesa.nome': 'Your name',
  'attesa.invia': 'Ask to join',
  'attesa.inviata': 'Request sent. Wait for the manager\'s approval: this page updates by itself.',
  'attesa.disattivo': 'This phone has been disabled. Ask the manager.',
  'attesa.codice': 'Phone code: {codice}',
  'attesa.lingua': 'Language',
  'agenda.titolo': 'Schedule',
  'agenda.oggi': 'Go to today',
  'agenda.prima': 'Previous day',
  'agenda.dopo': 'Next day',
  'agenda.filtro': 'Show the bookings of',
  'agenda.tutte': 'All',
  'agenda.tratt1': '1 treatment',
  'agenda.trattN': '{n} treatments',
  'agenda.compl': 'compl. {v}',
  'agenda.noShowDecidere': '{n} no-show to decide',
  'agenda.liberoFino': 'free until {ora}',
  'agenda.riordino': 'reset {n}\'',
  'agenda.conLettino': 'with B{n}',
  'agenda.vuota': 'No bookings',
  'agenda.lettino': 'Bed {n}',
  'agenda.ospite': 'guest',
  'agenda.inCarico': 'Loading the schedule…',
  'agenda.inSospeso': 'waiting for connection',
  'stato.confermata': 'Confirmed',
  'stato.arrivato': 'Guest arrived',
  'stato.fatto': 'Done',
  'stato.disdetta': 'Cancelled',
  'stato.no-show': 'No-show',
  'richieste.titolo': 'Phones to approve',
  'richieste.approva': 'Approve',
  'richieste.rifiuta': 'Reject',
  'richieste.colonna': 'Therapist column',
  'richieste.nessuna': 'none',
  'richieste.scegliRuolo': 'Choose at least one role.',
  'ruolo.responsabile': 'Manager',
  'ruolo.operatrice': 'Therapist',
  'ruolo.ricevimento': 'Reception',
  'ruolo.dev': 'Development',
  'agenda.prenota': '+ Book',
  'agenda.libero': 'free',
  'agenda.coppia': 'couple',
  'agenda.fuoriServizio': 'out of service',
  'stato.disdettaTardiva': 'Late cancellation · charged',
  'stato.disdettaGratuita': 'Free cancellation',
  'stato.noShowAddebito': 'No-show · charged',
  'stato.noShowGratis': 'No-show · not charged',
  'stato.noShowDaDecidere': 'No-show · charge to be decided',
  'op.breve': 'Op. {n}',
  'op.n': 'Therapist {n}',
  'foglio.chiudi': 'Close',
  'tipo.pagamento': 'Paid',
  'tipo.voucher': 'Gift voucher',
  'tipo.complimentary': 'Complimentary',
  'tipo.proprieta': 'Owner\'s account',
  'tag.voucher': 'voucher',
  'tag.complimentary': 'complimentary',
  'tag.proprieta': 'owner',
  'importo.pagamento': 'Amount €',
  'importo.voucher': 'Value € (already paid)',
  'importo.complimentary': 'Value € (offered)',
  'importo.proprieta': 'Value € (owner)',
  'paga.pos': 'POS (card)',
  'paga.contanti': 'Cash',
  'paga.dadecidere': 'To be decided',
  'modulo.nuova': 'New booking',
  'modulo.modifica': 'Edit',
  'modulo.ospite': 'Guest',
  'modulo.camera': 'Room',
  'modulo.cameraEs': '307 or EST.',
  'modulo.nome': 'Name',
  'modulo.esterno': 'External guest (not staying at the hotel)',
  'modulo.telefono': 'Phone',
  'modulo.email': 'Email',
  'modulo.paga': 'Pays at the SPA by',
  'modulo.caparra': 'Deposit €',
  'modulo.esternoSpiega': 'No room charge: pays at the SPA. Phone or email are needed to contact the guest.',
  'modulo.coppia': 'Couple: two beds in the same room',
  'modulo.inCoppia': 'Part of a couple: here you only edit this person.',
  'modulo.trattamento': 'Treatment',
  'modulo.seconda': 'Second person',
  'modulo.nome2Vuoto': 'if empty, same as the first',
  'modulo.operatrice': 'Therapist',
  'modulo.giorno': 'Day',
  'modulo.ora': 'Time',
  'modulo.primoLibero': 'Find the first free time',
  'modulo.libero': 'Free: {ora} · {dove} · {chi}',
  'modulo.liberoNo': 'No free time on this day for this treatment.',
  'modulo.liberoGiorno': 'Choose the day first.',
  'modulo.sala': 'Room',
  'modulo.lettino': 'Bed',
  'modulo.durata': 'Duration (min)',
  'modulo.pagamento': 'Payment',
  'modulo.prezzoIgnoto': 'price ?',
  'modulo.listino': 'Price list: {prezzo}',
  'modulo.listino2': '1st {a} · 2nd {b}',
  'modulo.motivoSconto': 'Reason for discount / shorter treatment',
  'modulo.scontoEs': 'e.g. shortened to 30\', guest\'s request',
  'modulo.motivoCompl': 'Reason for complimentary',
  'modulo.complEs': 'e.g. honeymoon, offered by the management',
  'modulo.magg': 'Guest is over 18',
  'modulo.carico': 'Loading the day…',
  'modulo.annulla': 'Cancel',
  'modulo.salvaNuova': 'Save booking',
  'modulo.salvaModifiche': 'Save changes',
  'modulo.quandoDove': 'When and where',
  'modulo.dalListino': 'From the menu',
  'modulo.daSoli': 'length and amount fill in by themselves',
  'modulo.tipo': 'Type',
  'modulo.controlli': 'Checks',
  'modulo.tuttoOk': 'Slot free: bed, room in service, therapist on shift and not on lunch break.',
  'modulo.soloServer': '“Saved” appears only after the server confirms.',
  'salute.titolo': 'Health · SPA staff only',
  'salute.titoloN': 'Health person {n} · SPA staff only',
  'salute.grav': 'Pregnancy',
  'salute.all': 'Allergies or sensitivities',
  'salute.note': 'Notes',
  'salute.spiega': 'They stay in the SPA app. Never shared with the reception.',
  'salute.salva': 'Save health',
  'salvato.nuova': '✓ Booking saved',
  'salvato.modifica': '✓ Changes saved',
  'salvato.stato': '✓ Saved: {stato}',
  'salvato.salute': '✓ Health card saved',
  'salvato.turni': '✓ Shifts saved',
  'salvato.addebito': '✓ Charge saved',
  'scheda.addebitoNoShow': 'No-show charge',
  'scheda.daDecidere': 'to be decided (manager)',
  'scheda.ospite':'Guest',
  'scheda.trattamento': 'Treatment',
  'scheda.operatrice': 'Therapist',
  'scheda.pagamento': 'Payment',
  'scheda.esterno': 'External',
  'scheda.sconto': 'Discount',
  'scheda.coppiaCon': 'In a couple with',
  'scheda.nota': 'Note',
  'scheda.senzaCamera': 'no room written',
  'scheda.senzaContatti': 'no contact',
  'scheda.pagaIn': 'pays at the SPA: {come}',
  'scheda.caparra': 'deposit {importo}',
  'scheda.listinoDurata': 'price list {durata}\'',
  'scheda.listinoPrezzo': 'price list {prezzo}',
  'scheda.modifica': 'Edit',
  'scheda.indietro': 'Back',
  'scheda.storico': 'History ({n})',
  'scheda.nonTrovata': 'Booking not found.',
  'azione.arrivato': 'Guest arrived',
  'azione.fatto': 'Treatment done',
  'azione.no-show': 'No-show',
  'azione.disdetta': 'Cancel booking',
  'azione.confermata': 'Back to confirmed',
  'disdetta.gratuita': '{ore} hours to go: free cancellation.',
  'disdetta.tardiva': 'Less than 24 hours to go: the full amount is charged ({importo}).',
  'disdetta.tardivaGratis': 'Less than 24 hours to go: full charge, but this treatment is not paid.',
  'disdetta.conferma': 'Confirm cancellation',
  'noshow.testo': 'The guest did not show up.',
  'noshow.daDecidere': 'The manager decides the amount to charge.',
  'noshow.importo': 'How much is charged? (from 0 to {max})',
  'noshow.errore': 'Write an amount from 0 to {max}.',
  'noshow.conferma': 'Confirm no-show',
  'noshow.decidi': 'Write the charge',
  'noshow.cambia': 'Change the charge',
  'noshow.salva': 'Save charge',
  'evento.crea': 'Created',
  'evento.modifica': 'Edited',
  'evento.dove': '{ora}, {sala} {lettino}, {op}',
  'evento.stato': 'Status: {stato}',
  'evento.nota.tardiva': 'late',
  'evento.nota.gratuita': 'free',
  'evento.salute': 'Health card updated',
  'evento.addebito': 'No-show charge: {importo}',
  'evento.addebitoInStato': 'charge {importo}',
  'turni.titolo': 'Shifts and lunch break',
  'turni.apri': 'Shifts and breaks',
  'turni.in': 'on shift',
  'turni.fuori': 'not on shift',
  'turni.conPausa': 'on shift · break {da}–{a}',
  'turni.nome': 'Name',
  'turni.inTurno': 'On shift',
  'turni.pausa': 'Lunch break (P.P)',
  'turni.nessunaPausa': 'No break',
  'turni.spiega': 'In the sheet: grey = not on shift, orange «P.P» = break. Here they block bookings automatically.',
  'turni.spiegaNomi': 'The name is valid for every day. Empty = «Therapist N».',
  'turni.conflitto': 'To be moved · {ora} {nome}: {problema}',
  'turni.salva': 'Save',
  'ctrl.fuoriOrario': 'Outside opening hours: the SPA works from {da} to {a} (this would end at {fine}).',
  'ctrl.fuoriTurno': '{op} is not on shift on {giorno}.',
  'ctrl.pausa': '{op} is on lunch break (P.P) from {da} to {a}.',
  'ctrl.fuoriServizio': '{sala} {lettini} out of service from {da} to {a}: {motivo}.',
  'ctrl.lettinoN': 'bed {n}',
  'ctrl.tuttiLettini': 'both beds',
  'ctrl.lettinoOccupato': 'Bed taken: {sala} {lettino} has {nome} from {da} to {a}, plus {riordino}\' to reset the room.',
  'ctrl.unOspite': 'a guest',
  'ctrl.impegnata': '{op} is already busy with {nome} from {da} to {a}.',
  'ctrl.giorno': 'Choose the day.',
  'ctrl.nome': 'Write the guest\'s name.',
  'ctrl.magg': 'Confirm the guest is over 18: the SPA only accepts adults.',
  'ctrl.motivoCompl': 'Write the reason for the complimentary (e.g. honeymoon).',
  'ctrl.coppiaOp': 'A couple needs two different therapists.',
  'ctrl.coppiaSala': 'A couple uses the two beds of the same room.',
  'ctrl.durata': 'Duration: write the minutes, from 15 to 240.',
  'ctrl.importo': 'Amount: write a number from 0 up.',
  'ctrl.motivoSconto': 'Price or duration below the price list: write the reason (e.g. shorter treatment, guest\'s request).',
  'ctrl.solo': '«{tr}» is for one person only: it cannot be booked for a couple.',
  'ctrl.trattamento': 'Choose the treatment.',
  'ctrl.persona': 'Person {n}: ',
  'ctrl.prezzoIgnoto': '{chi}the price of «{tr}» is not in the price list yet. Write it by hand.',
  'ctrl.importoZero': '{chi}amount is 0 €.',
  'ctrl.durataDaConf': '{chi}duration of «{tr}» to be confirmed: {durata}\' for now.',
  'ctrl.salaSolita': '«{tr}» is usually done in the {sala} room.',
  'ctrl.camera': 'Empty room: write the number, or tick «External guest».',
  'ctrl.estContatti': 'External guest: write a phone or email, they are needed to contact the guest.',
  'ctrl.email': 'The email looks wrong: check it.',
  'ctrl.caparraNeg': 'Deposit: write a number from 0 up.',
  'ctrl.caparraAlta': 'Deposit ({caparra}) higher than the total ({totale}).',
  'ctrl.estProprieta': 'External guest on «Owner\'s account»: check the payment.',
  'ctrl.grav': 'Pregnancy: check that the treatment is suitable before confirming.',
  'barra.titolo': 'Sections',
  'barra.oggi': 'Today',
  'barra.agenda': 'Schedule',
  'oggi.luogo': 'Villa Carola',
  'oggi.tratt1': 'treatment today',
  'oggi.trattN': 'treatments today',
  'oggi.occupati': 'beds booked',
  'oggi.incasso': 'takings of the day',
  'oggi.prossimi': 'Next',
  'oggi.vaiAgenda': 'Schedule ›',
  'oggi.nessuno': 'No more treatments today.',
  'oggi.daSapere': 'Good to know today',
  'oggi.niente': 'Nothing to report.',
  'oggi.coppia': '{tr} · couple',
  'oggi.lettino': '{sala} B{n}',
  'oggi.lettini': '{sala} B1 and B2',
  'oggi.due': '{a} and {b}',
  'barra.richieste': 'Requests',
  'oggi.richiesteRvc': 'Requests from RVC to answer: {n}',
  'ponte.luogo': 'Front desk',
  'ponte.titolo': 'Requests',
  'ponte.conta': '{n} to answer · from RVC',
  'ponte.spento': 'The bridge with RVC is not on.',
  'ponte.nonRaggiungibile': 'Bridge with RVC not reachable: retrying on its own.',
  'ponte.controllato': 'Bridge checked at {ora}',
  'ponte.nessuna': 'No requests to answer.',
  'ponte.nessunaFatta': 'No answered requests.',
  'ponte.fatte': 'Already answered',
  'ponte.regola24': 'Free cancellation up to 24 hours before. After that, the manager decides the charge.',
  'ponte.oggi': 'Today',
  'ponte.domani': 'Tomorrow',
  'ponte.camera': 'Room {n}',
  'ponte.esterno': 'Outside guest',
  'ponte.coppia': 'couple',
  'ponte.arrivata': 'arrived {ora} · {chi}',
  'ponte.prima': 'before: {quando}',
  'ponte.posto': '{sala} B{n} free · {op} on shift, outside the break',
  'ponte.postoCoppia': '{sala} B1 and B2 free · {a} and {b} on shift',
  'ponte.occupato': 'No room at {ora}.',
  'ponte.passata': 'The requested time has already passed.',
  'ponte.primoLibero': 'First free time: {quando} · {dove}',
  'ponte.giaGiusta': 'The booking is already on this day and time.',
  'ponte.spostaCoppia': 'Couple: move both bookings from the schedule, then confirm.',
  'ponte.errore.azione': 'Unclear request (unknown action): decline it and call the front desk.',
  'ponte.errore.data': 'Invalid day: decline it and call the front desk.',
  'ponte.errore.ora': 'Invalid time: decline it and call the front desk.',
  'ponte.errore.trattamento': 'Treatment not in the SPA menu: decline it and call the front desk.',
  'ponte.errore.persone': 'Invalid number of people for this treatment: decline it and call the front desk.',
  'ponte.errore.cliente': 'Room or outside guest name missing: decline it and call the front desk.',
  'ponte.errore.tipo': 'Unknown payment: decline it and call the front desk.',
  'ponte.conferma': 'Confirm',
  'ponte.proponi': 'Offer {ora}',
  'ponte.apri': 'Open the booking',
  'ponte.disdici': 'Open to cancel',
  'ponte.rifiuta': 'Decline',
  'ponte.rifiutaSicuro': 'Tap again to decline',
  'ponte.daRvc': 'Front desk request (RVC)',
  'ponte.chiesta': 'Requested by {chi} for {quando} at {ora}. Day and time stay as requested.',
  'ponte.salvataConferma': '✓ Booking saved and confirmed to RVC',
  'ponte.salvata.confermata': '✓ Confirmed to RVC',
  'ponte.salvata.altro-orario': '✓ Offer sent to RVC',
  'ponte.salvata.rifiutata': '✓ Declined: RVC can see it',
  'ponte.sulTelefono': '⏳ saved on the phone',
  'ponte.inInvio': 'sending to RVC…',
  'ponte.mandata': 'RVC notified',
  'ponte.stato.confermata': 'Confirmed',
  'ponte.stato.altro-orario': 'Other time',
  'ponte.stato.proposta': 'Offered {quando}',
  'ponte.stato.rifiutata': 'Declined',
  'ponte.stato.annullata': 'Cancelled by RVC',
};
